import React from "react";
import './App.css';
import './nav/Nav-Header'
import Main from "./Main"

import 'bulma/css/bulma.min.css';


function App() {

    return (
        <div className="App">
            <Main />
        </div>
    );
}


export default App;
